import { NAUGHTY_WORDS } from '../constants';
import {
  isEmptyString,
  isFunction,
  isNil,
  isString,
} from '../../../util/object';

/**
 * Checks if there is a NSFW or otherwise "bad" word they are searching for
 */
export const isSearchPhraseNaughty = (searchPhrase) => {
  for (const word of searchPhrase.split(' ')) {
    if (NAUGHTY_WORDS.has(word.toLowerCase())) {
      return true;
    }
  }
  return false;
};

/**
 * Removes leading and trailing whitespace on each line.
 */
export const sanitizeTextString = (textString) => {
  return textString
    .split('\n')
    .map((line) => line.trim())
    .join('\n');
};

/**
 * Trim end of string
 */
export const trimEnd = (string) => {
  if (!isString(string)) {
    throw new Error('Value needs to be a string');
  }

  if (isFunction(string.trimEnd)) {
    return string.trimEnd();
  }

  return string.replace(/\s+$/, '');
};

/**
 * @function capitalize
 * @param  {String} str
 * @return {String} Takes a string, uppercases the first char and lower cases rest
 */
export const capitalize = (str) =>
  str.charAt(0).toUpperCase() + str.toLowerCase().slice(1);

/**
 * @function camelCase
 * @param  {String} str
 * @return {String} Converts a set of words into camelCase.
 */
export const camelCase = (str) => {
  const string = str
    .toLowerCase()
    .replace(/[^A-Za-z0-9]/g, ' ')
    .split(' ')
    .reduce((result, word) => result + capitalize(word.toLowerCase()));
  return string.charAt(0).toLowerCase() + string.slice(1);
};

export const getFirstSplit = (str, splitOn = '.') => {
  if (isEmptyString(str)) {
    return str;
  }
  return str.split(splitOn)[0];
};

export const lowerCaseEquals = (str1, str2) => {
  if (isNil(str1) && isNil(str2)) return true;
  if (isNil(str1) || isNil(str2)) return false;
  return str1.toLowerCase() === str2.toLowerCase();
};

// Checks to see if this strings contains characters from right to left languages like arabic
export const isRTLText = (text) => {
  // This came from here: https://codepen.io/vsync/pen/rcwui
  const ltrChars =
    'A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF\u2C00-\uFB1C\uFDFE-\uFE6F\uFEFD-\uFFFF';
  const rtlChars = '\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC';
  const rtlDirCheck = new RegExp(`^[^${ltrChars}]*[${rtlChars}]`);

  return rtlDirCheck.test(text);
};
